export enum enPaymentStatus {
  IDLE = 'idle',
  PROGRESS = 'progress',
  SUCCESS = 'success',
  ERROR = 'error'
}


// WEBPACK FOOTER //
// ./src/enums/enPaymentStatus.ts